import React from 'react';
import { translate } from 'translations/i18n';
import { Tooltip, ButtonIcon } from '@companycam/slab-web';
import styled from 'styled-components';

const StyledButtonIcon = styled(ButtonIcon)`
  border-color: var(--cc_color_border_default);
  background-color: var(--cc_color_background_1);

  &:hover {
    background-color: var(--cc_color_background_1);
    border-color: var(--cc_color_border_default);
  }
`;

export const ReminderButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Tooltip placement="top" title={translate('reminders.buttonText')}>
      <StyledButtonIcon
        design="solid"
        shape="square"
        iconName="bell-outline"
        onClick={onClick}
        accessibilityLabel={translate('reminders.buttonText')}
      />
    </Tooltip>
  );
};
